module.exports = __webpack_public_path__ + "resources/img/img_db-i_cloud01.d7caa27a3f407964b1bbbb80e60e4d95.png";